import React from 'react';
import ReactCountUp from 'react-countup';

type Props = {
  decimals?: number;
  duration?: number;
  end: number;
  formattingFn?: (value: number) => string;
  [key: string]: any;
};

const CountUp = ({
  decimals = 2,
  duration = 1,
  end,
  formattingFn = (value: number) => value?.toLocaleString(),
  ...otherProps
}: Props): React.ReactElement => (
  <ReactCountUp
    decimals={Number.isInteger(end) ? 0 : decimals}
    duration={duration}
    end={end}
    formattingFn={formattingFn}
    {...otherProps}
  />
);

export default CountUp;
